exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".half-circle-spinner .circle-1{border-top-color:#0c4c91!important}.half-circle-spinner .circle-2{border-bottom-color:#59a2c1!important}", ""]);
// Exports
exports.locals = {
	"primary": "#0c4c91",
	"primaryLight": "#19b0de",
	"secondary": "#f5812d",
	"secondaryBright": "#c60b4e",
	"neutralLight": "#d9d9d9",
	"neutralBright": "#fdfdfd",
	"brandGrey": "#888786",
	"success": "#095"
};